export const DATE_FORMAT = "MM/DD/YYYY";
export const DATETIME_FORMAT="MM/DD/YYYY HH:mm"
export const DATE_FORMAT_LIST = ["YYYY-MM-DD", "MM/DD/YYYY", "MM-DD-YYYY"]